import { InfoCircleTwoTone } from '@ant-design/icons';
import { useView } from '@hooks';
import { Order } from '@services';
import { Button, Typography } from 'antd';

const { Text } = Typography;

interface IProps {
  relatedOrders: number;
  order: Order | undefined;
  onRelatedWorkClick?: () => void;
}

export const RelatedJobsInfoNote: React.FC<IProps> = ({
  order,
  relatedOrders,
  onRelatedWorkClick,
}) => {
  const { isMobile } = useView();
  const readonly =
    !order || order.status === 'Approval' || order.status === 'Paid' || order.status === 'Ready';

  if (relatedOrders === 0 && readonly) return null;

  return (
    <>
      <div
        style={{
          marginBottom: isMobile ? '8px' : '16px',
          padding: isMobile ? '8px 10px' : '12px 16px',
          background: '#f8f9fa',
          border: '1px solid #e9ecef',
          borderRadius: '8px',
          display: 'flex',
          alignItems: 'center',
          gap: isMobile ? '8px' : '12px',
          flexWrap: 'wrap',
          fontSize: isMobile ? 13 : undefined,
        }}
      >
        {/* Info icon and text */}
        <InfoCircleTwoTone style={{ fontSize: 18, verticalAlign: 'middle' }} />

        {relatedOrders > 0 ? (
          <Text style={{ fontSize: 14, marginRight: 8, verticalAlign: 'middle' }}>
            {readonly
              ? `You have ${relatedOrders} related bookings for this customer. View related bookings`
              : `You have ${relatedOrders} related bookings for this customer. You can view or create more bookings`}
          </Text>
        ) : (
          <Text style={{ fontSize: 14, marginRight: 8, verticalAlign: 'middle' }}>
            Create a separate booking
          </Text>
        )}

        <div
          style={{
            marginLeft: 'auto',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            color: 'rgba(0, 0, 0, 0.45)',
            fontSize: '12px',
          }}
        >
          {/* View button */}
          <Button
            type="default"
            size="small"
            onClick={() => onRelatedWorkClick?.()}
            style={{
              padding: '0 12px',
              fontSize: 13,
              height: 30,
              verticalAlign: 'middle',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {relatedOrders > 0 ? 'View related work' : 'Add related work'}
          </Button>
        </div>
      </div>
    </>
  );
};
